<template>
  <div id="disease-progression">
    <div class="inner-wrapper">
      <main class="inner-content">
        <SectionHeader />
        <div class="row">
          <SectionToggles />
          <div class="prog-block-container">
            <div class="col-50">
              <div class="mobility prog-block">
                <div class="content">
                  <h3>Mobility</h3>

                  <!-- <h4>Expanded Disability Status Scale (EDSS)</h4> -->
                  <EdssScore />
                  <router-link
                    @click.native="updateAnalytics('mobility')"
                    :to="{
                      name: 'visualization',
                      params: {
                        name: 'mobility',
                        year: $store.state.year,
                        startTab: 'mobility',
                      },
                    }"
                    class="zoom-link"
                    title="Mobility Link"
                  >
                    More
                  </router-link>

                  <!-- <EdssScale /> -->
                  <MobilityText />
                </div>

                <div class="bg">
                  <MobilityVideo :class="'scaled'" />
                </div>
              </div>
            </div>
            <div class="col-50 mri-neur-container">
              <div class="mri-results prog-block">
                <div class="content">
                  <h3>MRI Results</h3>

                  <router-link
                    @click.native="updateAnalytics('mri')"
                    :to="{
                      name: 'visualization',
                      params: {
                        name: 'mri-results',
                        year: $store.state.year,
                        startTab: 'mri',
                      },
                    }"
                    class="zoom-link"
                    title="MRI Results Link"
                  >
                    More
                  </router-link>

                  <MriResultsText />

                  <BrainImages />

                  <LesionsContent />
                </div>
              </div>
              <div class="neuronal-health prog-block">
                <div class="content">
                  <h3>Neuronal Health</h3>

                  <router-link
                    @click.native="updateAnalytics('neuronal')"
                    :to="{
                      name: 'visualization',
                      params: {
                        name: 'neuronal-health',
                        year: $store.state.year,
                        startTab: 'neuronal',
                      },
                    }"
                    class="zoom-link"
                    title="Neuronal Health Link"
                  >
                    More
                  </router-link>

                  <NeuronalHealthText />
                </div>
                <div class="bg">
                  <NeuronImages />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Findings />
      </main>
    </div>
  </div>
</template>

<script>
// import EdssScale from "@/components/EdssScale.vue";
import EdssScore from "@/components/EdssScore.vue";
// import YearSlider from "@/components/YearSlider.vue";
// import FindingsChart from "@/components/FindingsChart.vue";
// import FindingsCopy from "@/components/FindingsCopy.vue";
import Findings from "@/components/Findings.vue";

import MobilityVideo from "@/components/MobilityVideo.vue";
import MobilityText from "@/components/MobilityText.vue";

import MriResultsText from "@/components/MriResultsText.vue";
import BrainImages from "@/components/BrainImages.vue";
import LesionsContent from "@/components/LesionsContent.vue";

import NeuronalHealthText from "@/components/NeuronalHealthText.vue";
import NeuronImages from "@/components/NeuronImages.vue";

import SectionHeader from "@/components/SectionHeader.vue";
import SectionToggles from "@/components/SectionToggles.vue";

export default {
  name: "DiseaseProgression",
  components: {
    // EdssScale,
    EdssScore,
    Findings,
    // YearSlider,
    // FindingsChart,
    // FindingsCopy,
    MobilityVideo,
    MobilityText,
    MriResultsText,
    BrainImages,
    LesionsContent,
    NeuronalHealthText,
    NeuronImages,
    SectionHeader,
    SectionToggles,
  },
  data() {
    return {
      showFade: true,
      showFadeLeft: false,
    };
  },
  mounted() {
    this.$store.setDetailedTab("");
  },
  methods: {
    updateAnalytics(type) {
      if (this.$store.state.year > 10) {
        this.$gtag.event("click", {
          event_category: `launch_${type}`,
          event_label: `spms: ${this.$store.state.year}`,
        });
      } else if (this.$store.state.year > 5 && this.$store.state.year < 11) {
        this.$gtag.event("click", {
          event_category: `launch_${type}`,
          event_label: `late rrms: ${this.$store.state.year}`,
        });
      } else if (this.$store.state.year > 0 && this.$store.state.year < 6) {
        this.$gtag.event("click", {
          event_category: `launch_${type}`,
          event_label: `early rrms: ${this.$store.state.year}`,
        });
      } else {
        this.$gtag.event("click", {
          event_category: `launch_${type}`,
          event_label: "healthy",
        });
      }
    },
    handleScroll(e) {
      const el = e.srcElement;
      this.showFade = el.scrollLeft < el.scrollWidth - el.offsetWidth;
      this.showFadeLeft = el.scrollLeft > 10;
    },
  },
};
</script>

<style lang="scss">
#disease-progression {
  width: 100%;
  position: relative;
  .page-title {
    margin-bottom: rem(10px);
  }

  // Override for 1024px view, copy to be included at 1400px viewport
  #mobility-text,
  #mri-results-text,
  #lesions-copy,
  #neuronal-health-text {
    display: none;
  }

  .prog-block-container {
    @include breakpoint(lg) {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .mri-neur-container {
    width: calc(50% - 10px);
    @include breakpoint(lg) {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .prog-block {
    position: relative;

    &:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      -webkit-box-shadow: inset 3px 3px 150px 9px rgba(0, 0, 0, 0.5);
      -moz-box-shadow: inset 3px 3px 150px 9px rgba(0, 0, 0, 0.5);
      box-shadow: inset 3px 3px 150px 9px rgba(0, 0, 0, 0.5);
    }

    h3 {
      font-size: rem(14px);
      margin: 0 0 0.5rem;
      text-transform: uppercase;
    }

    .content,
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .content {
      z-index: 1;
      padding: rem(16px);

      .prog-text {
        p {
          font-size: rem(10px);
          line-height: 1.2;
        }
      }
    }

    .bg {
      z-index: 0;
      overflow: hidden;
    }
  }

  .mobility {
    width: 100%;
    height: 525px;
    @include breakpoint(xs) {
      height: 350px;
    }
  }

  .edss-score {
    top: 18%;
    left: 50%;
    @include breakpoint(md) {
      font-size: 1.5rem;
    }
    @include breakpoint(xs) {
      font-size: 1rem;
    }
    @media (max-width: 600px) {
      font-size: 0.75rem;
    }
    @media (max-width: 450px) {
      left: 47%;
    }
    span {
      &.score {
        @include breakpoint(md) {
          font-size: rem(75px);
        }
        @include breakpoint(xs) {
          font-size: rem(70px);
          margin-right: 0.3rem;
        }
        @media (max-width: 600px) {
          font-size: rem(35px);
        }
      }
    }
  }

  #mobility-video {
    left: -25%;
    @include breakpoint(lg) {
      left: -10%;
    }
    &.scaled {
      @include breakpoint(lg) {
        width: 75%;
      }
    }
  }

  .mri-results {
    width: 100%;
    height: 255px;
    background: transparent;
    background: rgba(255, 255, 255, 0.19);
    border-radius: 10px;
    margin-left: 10px;
    &::after {
      content: none;
    }
    @include breakpoint(xs) {
      height: 167px;
    }
  }

  .neuronal-health {
    width: 100%;
    height: 255px;
    background: rgba(255, 255, 255, 0.19);
    border-radius: 10px;
    margin-top: 15px;
    margin-left: 10px;
    &::after {
      content: none;
    }
    @include breakpoint(lg) {
      margin-top: 0;
    }
    @include breakpoint(xs) {
      height: 167px;
    }
  }

  #neuron-images {
    @include breakpoint(lg) {
      top: 50px;
    }
  }

  #lesions-content {
    // top: 50%;
    .mri-images {
    }
  }

  .zoom-link {
    display: inline-block;
    position: absolute;
    bottom: 0.75rem;
    right: 1rem;
    padding: 3px 7px;
    text-decoration: none;
    font-size: rem(12px);
    border: 2px solid $blue-light;
    border-radius: 5px;
    background: $blue-dark-bg;
    img {
      width: 100%;
    }

    &:focus {
      outline: 4px solid#FFD086;
    }
  }

  .row.chart {
    position: relative;
    z-index: 1;
    // background: white;

    > .col-100 {
      // padding: 0 rem(20px) rem(20px);
    }

    * {
      // color: $blue-dark-bg;
    }

    > div > h3 {
      // padding: 1rem 0;
    }
  }
}
</style>
